import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

// Grows to fill the remaining viewport height (requires hasFullHeightContent on the header
// wrapper) so the sticky CTA footer is pushed to the bottom and never overlaps the last item.
export const GeneralWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1 0 auto;
`;

export const SelectedSourceWrapper = styled.div<{ multipleSources?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${(props) => (props.multipleSources ? DesignConstants.SPACES.XS : 0)};

    :last-child {
        margin: 0;
    }
`;

export const SelectBookVocabularyWrapper = styled.div`
    width: 100%;
    position: relative;
`;

export const BookWrapper = styled.div<{ borderActive?: boolean; showBorder?: boolean }>`
    display: flex;
    align-items: center;
    flex-direction: row;
    flex: 1;
    flex-shrink: 0;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    border: ${(props) =>
        props.borderActive
            ? props.showBorder
                ? `${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.P6_ORANGE}`
                : `${DesignConstants.BORDERS.THIN} transparent`
            : ""};
    padding: ${(props) => (props.borderActive ? DesignConstants.SPACES.XS : "")};
    cursor: ${(props) => (props.borderActive ? "pointer" : "")};
`;

export const DifferentSourceWrapper = styled.div<{ alignBottom?: boolean }>`
    display: flex;
    flex-direction: column;
    align-self: ${(props) => (props.alignBottom ? "flex-end" : "")};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
        align-self: stretch;

        > * {
            width: 100%;
        }
    }
`;

export const BookHeaderInfo = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    background: white;
    gap: ${DesignConstants.SPACES.S};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const BookImageWrapper = styled.div`
    margin-right: ${DesignConstants.SPACES.S};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const DashedCoverPlaceholder = styled.div`
    width: 94px;
    height: 128px;
    border: 2px dashed ${DesignConstants.COLORS.MID_GREY};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    flex-shrink: 0;
    margin: -1px 0 -1px -1px;
`;

export const EmptyOwnContentCard = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.S};
    padding-right: ${DesignConstants.SPACES.S};
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.LIGHTEST_GREY};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
`;

export const BookNameWrapper = styled.div``;

export const BookName = styled.h4`
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    font-size: ${DesignConstants.FONT_SIZES.L};
    margin: 0;
`;

export const SmallSelectWrapper = styled.div`
    flex: 1;
    padding-right: ${DesignConstants.SPACES.XS};

    input {
        color: black;
    }

    .select-search__input,
    .select-search__input:focus {
        border: none;
        box-shadow: none;
    }

    .select-search__select {
        box-shadow: none;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
    }
`;

export const ExerciseToSpan = styled.span`
    font-size: ${DesignConstants.FONT_SIZES.S};
`;

export const VocabularyHeading = styled.p`
    font-size: ${DesignConstants.FONT_SIZES.M};
`;

export const VocabularyHeadingAndListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.XS};
`;

// The negative horizontal margin cancels the AccordionTabDetailsWrapper SPACES.S padding so the
// divider touches the card's left/right edges. Keep this in sync with that wrapper's padding.
export const Line = styled.div`
    border-bottom: ${DesignConstants.BORDERS.THIN_GREY};
    margin: 0 -${DesignConstants.SPACES.S};
`;

export const StickyWrapper = styled.div`
    position: sticky;
    bottom: ${DesignConstants.SPACES.XXL};
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    width: calc(100vw - ${DesignConstants.SPACES.L});
    max-width: calc(${process.env.REACT_APP_UPPER_GRID_STEP_BORDER}px - ${DesignConstants.SPACES.L});
    padding: ${DesignConstants.SPACES.XS} 0;
`;
